import { useMutation, useQueryClient } from '@tanstack/react-query';
import dayjs from 'dayjs';
import Api, { withAcl } from 'hooks/Api';
import { toastSuccess } from 'ui/partials/Toast';
import { useAdminParams } from 'utils/helpers';
import useModal from 'ui/partials/Modal/useModal';
import { useProvider } from 'utils/providers/Provider';
import { Event } from 'utils/types';
import partialConstants from 'ui/partials/utils/constants';

import contactsConstants from '../../contact/utils/constants';
import c from '../utils/constants';

export default function useDeleteEvent(date: Date | string) {
  const queryClient = useQueryClient();
  const { hideModal } = useModal();
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  return useMutation({
    mutationFn: async (payload: string) => {
      const api = new Api(args);

      const data = await api.delete(
        await withAcl({
          account: {
            url: `api/v1/calendar/events/${payload}`,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/calendar/events/${payload}`,
          },
        }),
      );

      return data;
    },
    onSuccess: (_, payload) => {
      const data = queryClient.getQueryData([
        c.EVENT_UPCOMING,
        {
          date: dayjs(date).startOf('day'),
        },
      ]);

      if (data) {
        queryClient.setQueryData(
          [
            c.EVENT_UPCOMING,
            {
              date: dayjs(date).startOf('day'),
            },
          ],
          //TODO: Type this properly
          (prev: any) => prev.filter((event: Event) => event._id !== payload),
        );

        const { dealId } = (data as Event[]).find(
          (event: Event) => event._id === payload,
        ) as Event;

        if (dealId) {
          queryClient.invalidateQueries({ queryKey: [c.LOGS, dealId] });
          queryClient.invalidateQueries({
            queryKey: [
              c.EVENTS,
              {
                'include[0]': 'accountUser',
                'include[1]': 'guests',
                dealId,
              },
            ],
          });
        }
      }

      queryClient.invalidateQueries({ queryKey: [c.EVENTS, {}] });
      queryClient.invalidateQueries({
        queryKey: [contactsConstants.LEADS],
      });
      queryClient.invalidateQueries({
        queryKey: [partialConstants.TAGS],
      });

      hideModal();
      toastSuccess('Successfully cancelled event.');
    },
  });
}
